import { Text, type TextProps } from '@pets-ui/Text/Text'
import { type MobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { type VStackProps } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { type ComponentPropsWithoutRef } from 'react'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'
const styles = stylex.create({
  input: {
    padding: 6,
    borderColor: colors.grey300,
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 0.5,
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    color: colors.grey500,
    height: 40,
    maxWidth: {
      [MOBILE]: '100%',
      default: 264,
    },
    width: '100%',
  },
  inputFullWidth: {
    maxWidth: '100%',
  },
  inputError: {
    borderColor: colors.red600,
  },
})

export interface CreditCardInputFieldProps extends Omit<ComponentPropsWithoutRef<'div'>, 'className' | 'style'> {
  rootRef?: VStackProps['rootRef']
  errorMessage?: string
  errorMessageVariant?: TextProps['variant']
  style?: stylex.StyleXStyles
  fullWidth?: boolean
}

export const CreditCardInputField = (props: CreditCardInputFieldProps) => {
  const { rootRef, errorMessage, errorMessageVariant, style, fullWidth, children, ...rest } = props
  const error = !!errorMessage
  return (
    <VStack rootRef={rootRef} gap={1}>
      <div {...stylex.props(styles.input, fullWidth && styles.inputFullWidth, error && styles.inputError, style)} {...rest}>
        {children}
      </div>
      {error && <Text variant={errorMessageVariant} color={colors.red600}>{errorMessage}</Text>}
    </VStack>
  )
}
